// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3VMbN","title":"BackImages_title__2KPlq","images":"BackImages_images__1yVlJ"};